(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azvon-boutique"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('azvon-depth')) {
    customElements.define('azvon-depth', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.media = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        this.toggle = this.querySelector('button');
        this.paused = false;
        const reset = () => {
          cancelAnimationFrame(this.frame);
          this.frame = null;
          ['--az-rx','--az-ry','--az-px','--az-py'].forEach(key => this.style.removeProperty(key));
        };
        const sync = () => {
          this.toggle.hidden = !this.media.matches;
          this.dataset.motion = this.media.matches && !this.paused ? 'active' : 'off';
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.textContent = this.paused ? this.dataset.resume : this.dataset.pause;
          reset();
        };
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; sync(); }, {signal});
        this.media.addEventListener('change', sync, {signal});
        this.addEventListener('pointermove', event => {
          if (this.dataset.motion !== 'active' || event.pointerType === 'touch') return;
          const rect = this.getBoundingClientRect();
          this.x = Math.max(-1,Math.min(1,((event.clientX-rect.left)/rect.width-.5)*2));
          this.y = Math.max(-1,Math.min(1,((event.clientY-rect.top)/rect.height-.5)*2));
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.style.setProperty('--az-rx',`${-this.y*5}deg`);
            this.style.setProperty('--az-ry',`${this.x*6}deg`);
            this.style.setProperty('--az-px',`${this.x*12}px`);
            this.style.setProperty('--az-py',`${this.y*10}px`);
            this.frame = null;
          });
        }, {signal,passive:true});
        this.addEventListener('pointerleave', reset, {signal});
        this.addEventListener('pointercancel', reset, {signal});
        this.addEventListener('focusout', reset, {signal});
        sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
        this.bound = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azvon-home"] && !Shopify.designMode) return;
  try {
    
  function initAzvonHome(root) {
    if (!root || root.dataset.azReady) return;
    root.dataset.azReady = 'true';
    const filters = root.querySelector('.az-filters');
    if (!filters) return;
    filters.hidden = false;
    filters.addEventListener('click', (event) => {
      const button = event.target.closest('[data-az-filter]');
      if (!button) return;
      const category = button.dataset.azFilter;
      root.querySelectorAll('[data-az-category]').forEach(card => { card.hidden = category !== 'all' && card.dataset.azCategory !== category; });
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  }
  document.querySelectorAll('.az-home').forEach(initAzvonHome);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.az-home').forEach(initAzvonHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azvon-product-help"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('azvon-size-finder')) {
    customElements.define('azvon-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const form = this.querySelector('form');
        const output = this.querySelector('[role="status"]');
        form.addEventListener('input', () => { output.textContent = ''; });
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const chest = Number(form.elements.chest.value);
          const neck = Number(form.elements.neck.value);
          const sizes = [
            { name: 'S', chest: [45, 51], neck: [40, 48] },
            { name: 'M', chest: [52, 60], neck: [45, 54] },
            { name: 'L', chest: [63, 77], neck: [54, 67] },
            { name: 'XL', chest: [72, 91], neck: [60, 70] }
          ];
          const matches = sizes.filter(size => chest >= size.chest[0] && chest <= size.chest[1] && neck >= size.neck[0] && neck <= size.neck[1]);
          output.textContent = matches.length ? this.dataset.match.replace('[sizes]', matches.map(size => size.name).join(' / ')) : this.dataset.noMatch;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azvon-product-studio"] && !Shopify.designMode) return;
  try {
    
const studioControllers = new WeakMap();
function initProductStudio(scope = document) {
  scope.querySelectorAll('[data-studio]').forEach(root => {
    if (studioControllers.has(root)) return;
    const controller = new AbortController(), signal = controller.signal;
    const visual = root.querySelector('[data-visual]'), tilt = root.querySelector('[data-tilt]'), motion = root.querySelector('[data-motion]');
    if (!visual || !tilt || !motion) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)'), fine = matchMedia('(pointer: fine)');
    let paused = false, frame = null, rect = null, x = 0, y = 0;
    const reset = () => { cancelAnimationFrame(frame); frame = null; tilt.style.setProperty('--rx','0deg'); tilt.style.setProperty('--ry','0deg'); };
    const sync = () => { reset(); motion.hidden = reduced.matches || !fine.matches; motion.setAttribute('aria-pressed',String(paused)); motion.textContent = paused ? motion.dataset.resume : motion.dataset.pause; };
    visual.addEventListener('pointerenter', () => { rect = visual.getBoundingClientRect(); }, {signal,passive:true});
    visual.addEventListener('pointermove', event => {
      if (paused || reduced.matches || !fine.matches || event.pointerType === 'touch') return;
      rect ||= visual.getBoundingClientRect();
      x = Math.max(-.5,Math.min(.5,(event.clientX-rect.left)/rect.width-.5));
      y = Math.max(-.5,Math.min(.5,(event.clientY-rect.top)/rect.height-.5));
      if (frame !== null) return;
      frame = requestAnimationFrame(() => { tilt.style.setProperty('--rx',(-y*10)+'deg'); tilt.style.setProperty('--ry',(x*12)+'deg'); frame = null; });
    }, {signal,passive:true});
    visual.addEventListener('pointerleave', () => { rect = null; reset(); }, {signal});
    visual.addEventListener('pointercancel', reset, {signal});
    motion.addEventListener('click', () => { paused = !paused; sync(); }, {signal});
    reduced.addEventListener('change', sync, {signal}); fine.addEventListener('change', sync, {signal});
    window.addEventListener('resize', () => { rect = null; reset(); }, {signal,passive:true});
    window.addEventListener('scroll', () => { rect = null; }, {signal,passive:true});
    document.addEventListener('visibilitychange', () => { if(document.hidden) reset(); }, {signal});
    const select = root.querySelector('[data-variant]');
    if (select) select.addEventListener('change', () => {
      const option = select.selectedOptions[0], button = root.querySelector('[data-add]'), price = root.querySelector('.az-studio__price');
      if (!option || !button || !price) return;
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price;
      button.disabled = !available; button.textContent = available ? button.dataset.label : button.dataset.sold;
      const url = new URL(location.href); url.searchParams.set('variant',option.value); history.replaceState({},'',url);
    }, {signal});
    studioControllers.set(root, () => { reset(); controller.abort(); studioControllers.delete(root); });
    sync();
  });
}
initProductStudio();
document.addEventListener('shopify:section:load', event => initProductStudio(event.target));
document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-studio]').forEach(root => studioControllers.get(root)?.()); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
